import React from "react"

import { cn } from "@productlane/lib/src/cn"

interface EditorMenuButtonProps {
	onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void
	isActive: boolean
	className?: string
	children: React.ReactNode
}

export const EditorMenuButton: React.FC<EditorMenuButtonProps> = ({
	onClick,
	isActive,
	className = "",
	children,
}) => {
	return (
		<button
			type="button"
			onMouseDown={(e) => e.preventDefault()}
			onClick={onClick}
			className={cn(
				"rounded p-2 text-lg text-secondary hover:bg-gray-100 hover:text-primary hover:dark:bg-gray-800",
				isActive
					? `fill-black text-xl text-black dark:fill-gray-100 dark:text-gray-100 ${className}`
					: `fill-gray-500 text-xl text-gray-500 hover:fill-gray-800 hover:text-gray-800 dark:fill-gray-400 dark:text-gray-400 dark:hover:fill-gray-100 dark:hover:text-gray-100 ${className}`,
			)}
		>
			{children}
		</button>
	)
}
